var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('top',{attrs:{"open-audio":_vm.openAudio},on:{"openCloseAudio":_vm.openCloseAudio}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }